import React, { Component } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import CtBtn from "../Components/CustomTool/CtBtn";
import CtTxt from "../Components/CustomTool/CtTxt";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import AlertResponsiveDialog from "../Components/CustomTool/AlertResponsiveDialog";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import {
  applyTrimOnObjectValues,
  csvFileName,
  getRowOfRT,
  setKeyboardShortcuts,
} from "../SystemUtility/SystemUtility";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { connect } from "react-redux";
import { withRouter } from "../HOC/withRouter";
import CtART from "./CustomTool/ResponsiveTable";
import { fetchBlockedBy } from "./API";

class BlockedBy extends Component {
  state = {
    columnsdata: [
      {
        accessorKey: "bint_srno",
        header: "SR No",
        size: 10,
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_blockby",
        header: "Blocked By",
        size: 300,
      },
    ],

    rows: [{ bint_srno: 1, vac_blockby: "Blocked By 1" }],
    formData: {
      bint_srno: 0,
      txtBlockedBy: "",
    },
    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
  };

  //#region Component
  componentDidMount() {
    localStorage.setItem("Heading", "Blocked By");
    this.props.verifyUserID(this.getInfo, this.props.setUserPrivileges);
    this.ShortCut();
  }

  componentWillUnmount() {
    this.removeShortCut();
  }

  //#endregion Component

  //#region Handle

  ShortCut = () => {
    this.removeShortCut = setKeyboardShortcuts(
      this.saveBlockedBy,
      this.clearInfo,
      () => {
        this.DeleteData(
          this.state.formData.bint_srno,
          this.state.formData.txtBlockedBy,
        );
      },
    );
  };

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleARDonActionClick_Edit = (rtRow) => {
    const row = getRowOfRT(rtRow, ["bint_srno", "vac_blockby"]);
    const bint_srno = row.bint_srno,
      txtBlockedBy = row.vac_blockby;
    this.setState({
      formData: {
        ...this.state.formData,
        bint_srno,
        txtBlockedBy,
      },
    });
    document.getElementById("txtBlockedBy").focus();
  };

  handleARDonActionClick_Delete = (rtRow) => {
    const row = getRowOfRT(rtRow, ["bint_srno", "vac_blockby"]);
    this.DeleteData(row.bint_srno, row.vac_blockby);
  };

  //#endregion Handle

  //#region function

  getInfo = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "ListBlockedBy",
    };
    fetchBlockedBy(reqData)
      .then((res) => {
        this.props.closeUpdateProcessing();
        let rows = res.data.BlockedByList || [],
          rowsCount = rows.length;

        this.setState({
          rowsCount,
          rows,
        });
      })
      .catch((error) => {
        console.log("Unknown error occurred in onFormLoad.", error);
      });
    document.getElementById("txtBlockedBy").focus();
  };

  clearInfo = () => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          bint_srno: 0,
          txtBlockedBy: "",
        },
      },
      () => {
        document.getElementById("txtBlockedBy").focus();
      },
    );
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validationBlockedBy = () => {
    let result = false;
    if (this.state.formData.txtBlockedBy.length <= 0) {
      this.props.toastErrorMsg("Enter Blocked By", "txtBlockedBy");
    } else {
      result = true;
    }
    return result;
  };

  saveBlockedBy = () => {
    this.trimFormData(() => {
      if (this.validationBlockedBy()) {
        this.props.notifyProcessing();
        const reqData = {
          Op: "SaveBlockedBy",
          bint_srno: this.state.formData.bint_srno,
          vac_blockby: this.state.formData.txtBlockedBy,
        };
        fetchBlockedBy(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              let rows = [],
                rowsCount = rows.length;
              if (res.data.BlockedByList && res.data.BlockedByList.length > 0) {
                rows = res.data.BlockedByList;
                rowsCount = rows.length;
              }
              this.setState(
                {
                  rows,
                  rowsCount,
                },
                () => {
                  this.clearInfo();
                },
              );
            }
          })
          .catch((error) => {
            console.log("Unknown error occurred in Save Blocked By.", error);
          });
      }
    });
  };

  DeleteData = (bint_srno, vac_blockby) => {
    if (bint_srno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={`Do you want to Delete : ${vac_blockby} ?`}
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteBlockedBy(bint_srno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteBlockedBy = (bint_srno) => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "DeleteBlockedBy",
      bint_srno: bint_srno,
    };
    fetchBlockedBy(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          let rows = [],
            rowsCount = rows.length;
          if (res.data.BlockedByList && res.data.BlockedByList.length > 0) {
            rows = res.data.BlockedByList;
            rowsCount = rows.length;
          }
          this.setState(
            {
              rows,
              rowsCount,
              ARD: null,
            },
            () => {
              this.clearInfo();
            },
          );
        }
      })
      .catch((error) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in delete Blocked By. " + error,
        );
      });
    return false;
  };

  //#endregion function

  render() {
    return (
      <form>
        <Grid container direction="row" justifyContent="flex-end">
          <Grid item>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <CtBtn
                  className="secondary-button"
                  label="Save"
                  iconName="save"
                  onClick={this.saveBlockedBy}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="New"
                  className="new-button"
                  iconName="new"
                  onClick={this.clearInfo}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Delete"
                  className="delete-button"
                  iconName="delete"
                  onClick={() => {
                    this.DeleteData(
                      this.state.formData.bint_srno,
                      this.state.formData.txtBlockedBy,
                    );
                  }}
                  disabled={this.state.formData.bint_srno > 0 ? false : true}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxt
              id="txtBlockedBy"
              label="Blocked By*"
              value={this.state.formData.txtBlockedBy}
              handleOnChange={this.handleOnChange}
              width={220}
              maxLength={100}
              onKeyDown={this.props.onKeyDown}
              defaultAction={this.saveBlockedBy}
            />
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={1}
          marginTop={1}
        >
          <Grid item className="maintable">
            <CtART
              rowsdata={this.state.rows}
              columnsdata={this.state.columnsdata}
              rowsPerPage={this.state.rowsPerPage}
              tblmaxHeight={500}
              csvFileName={csvFileName("Blocked By")}
              rowIconAction={[
                {
                  label: "Edit",
                  onClick: this.handleARDonActionClick_Edit,
                  icon: "Edit",
                  className: "secondary-button",
                },
                {
                  label: "Delete",
                  onClick: this.handleARDonActionClick_Delete,
                  icon: "delete",
                  className: "delete-button",
                },
              ]}
              showColumnFilters={false}
              actionColSize={30}
              density={"compact"}
              hideColIdList={[""]}
            />
          </Grid>
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

function WithNavigate(props) {
  let navigate = useNavigate();
  return <BlockedBy {...props} navigate={navigate} />;
}
export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps,
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
